import React from "react";

function LeftArrow({className, color}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="8"
      height="14"
      fill="none"
      viewBox="0 0 8 14"
      className={className}
    >
      <path
        stroke={color || "#fff"}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M7 13L1 7l6-6"
      ></path>
    </svg>
  );
}

export default LeftArrow;